import React, { useState } from 'react'
import { Dropdown } from 'react-bootstrap'
import { FaGear, FaCircleCheck, FaCircle } from 'react-icons/fa6'
import { StyledDropdownMenu } from './StyledDropdownMenu'
import { providers, type Provider } from '../helpers/providers'
import { useKusama } from '../kusama/KusamaContext'

const SettingsDropdown = () => {
  const currentUrl = new URL(window.location.href)

  const prodProviders = providers.filter((provider) => provider.dev === false)
  const devProviders = providers.filter((provider) => provider.dev === true)

  const { activeProviderEndpoint } = useKusama()

  const ProvidersList = ({ providers }: { providers: Provider[] }): JSX.Element => {
    const [hoveredItem, setHoveredItem] = useState('')

    return (
      <>
        {providers.map(({ name, url }, key) => {
          currentUrl.searchParams.set('rpc', url)

          return url === activeProviderEndpoint ? (
            <Dropdown.ItemText key={key}>
              <FaCircleCheck size={14} />
              {name}
            </Dropdown.ItemText>
          ) : (
            <Dropdown.Item
              href={currentUrl.toString()}
              key={key}
              onMouseEnter={() => setHoveredItem(url)}
              onMouseLeave={() => setHoveredItem('')}
            >
              {hoveredItem === url ? <FaCircleCheck size={14} /> : <FaCircle size={14} />}
              {name}
            </Dropdown.Item>
          )
        })}
      </>
    )
  }

  return (
    <Dropdown>
      <Dropdown.Toggle variant="success" id="dropdown-basic">
        <FaGear className="m-1 mt-0" />
        <span className="d-none d-lg-inline">Settings</span>
      </Dropdown.Toggle>

      <StyledDropdownMenu>
        <Dropdown.ItemText>RPC Providers</Dropdown.ItemText>
        <Dropdown.Divider />
        <ProvidersList providers={prodProviders} />
        <Dropdown.Divider />
        <ProvidersList providers={devProviders} />
      </StyledDropdownMenu>
    </Dropdown>
  )
}

export { SettingsDropdown }
